var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":_vm.download,"target":"_blank"}},[_c('div',[_c('span',{staticClass:"family"},[_vm._v(_vm._s(_vm.family))]),_c('span',{staticClass:"foundry"},[_vm._v(_vm._s(_vm.foundry))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }